import React, { useEffect } from 'react'
import { useReportFormInfo } from 'Pages/ReportsAlerts/Reports/@hooks'
import { reportFormData } from 'Pages/ReportsAlerts/Reports/@signals'
import { object, string } from 'yup'
import { AppAntSwitch, AppAsyncOfficesAutocomplete } from '@components'
import { Grid } from '@mui/material'
import { useComputed, useSignal } from '@preact/signals-react'
import { isEmpty } from '@ui-seeker/utils'

export default function OfficeDropoffField() {
	const showDropoff = useSignal(!!reportFormData.peek()?.idOfficeDropoff)

	return <Grid container spacing={2}>
		<Grid item xs={8}>
			{showDropoff.value && <OfficeField/>}
		</Grid>
		<Grid item xs={4}>
			<AppAntSwitch
				trueText="More Features"
				checked={showDropoff.value}
				onChange={() => showDropoff.value = !showDropoff.value}
			/>
		</Grid>
	</Grid>
}


function OfficeField() {

	const disableField = useComputed(() => reportFormData.value.idOfficePickup?.length > 1 || reportFormData.value.idOfficeGroup?.length >= 1)

	useEffect(() => {
		if (disableField.value && !isEmpty(reportFormData.value)) setIdOfficeDropoffInfo(null)
	}, [disableField.value])

	const {
		idOfficeDropoff,
		setIdOfficeDropoffInfo,
		error,
	} = useReportFormInfo(reportFormData.peek().idOfficeDropoff, 'idOfficeDropoff', object({ idOfficeDropoff: string().nullable() }))

	return <AppAsyncOfficesAutocomplete
		label="Dropoff Office"
		disabled={disableField.value}
		placeholder="Select a Dropoff Office"
		value={idOfficeDropoff || []}
		error={error}
		onChange={e => setIdOfficeDropoffInfo(e.target.value)}
	/>


}